import { OrdersActionTypes } from "./constants";

const INIT_STATE = {
  list: [],
  total: 0,
  one: null,
  loading: false,
};

interface OrderCreate {
  country: string;
  comment: string;
  description: string;
  orderDate: Date;
  from: any;
  mode: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
  transporterName: string;
  transporterPhone: string;
  weight: number;
}

interface OrdersData {
  items?: any[];
  total?: number;
}

interface GetOrdersData {
  id: string;
}

interface OrdersActionType {
  type:
    | OrdersActionTypes.GET_LIST_ORDERS
    | OrdersActionTypes.GET_LIST_ORDERS_ERROR
    | OrdersActionTypes.GET_LIST_ORDERS_SUCCESS
    | OrdersActionTypes.CREATE_ORDER
    | OrdersActionTypes.CREATE_ORDER_SUCCESS
    | OrdersActionTypes.CREATE_ORDER_ERROR
    | OrdersActionTypes.GET_ORDER
    | OrdersActionTypes.GET_ORDER_SUCCESS
    | OrdersActionTypes.GET_ORDER_ERROR
    | OrdersActionTypes.UPDATE_ORDER
    | OrdersActionTypes.UPDATE_ORDER_SUCCESS
    | OrdersActionTypes.UPDATE_ORDER_ERROR
    | OrdersActionTypes.UPDATE_STATUS_ORDER
    | OrdersActionTypes.UPDATE_STATUS_ORDER_SUCCESS
    | OrdersActionTypes.UPDATE_STATUS_ORDER_ERROR
    | OrdersActionTypes.DELETE_ORDER
    | OrdersActionTypes.DELETE_ORDER_SUCCESS
    | OrdersActionTypes.DELETE_ORDER_ERROR
    | OrdersActionTypes.DOWNLOAD_SAMPLE
    | OrdersActionTypes.DOWNLOAD_SAMPLE_SUCCESS
    | OrdersActionTypes.DOWNLOAD_SAMPLE_ERROR
    | OrdersActionTypes.UPLOAD_MULTIPLE_ORDERS
    | OrdersActionTypes.UPLOAD_MULTIPLE_ORDERS_SUCCESS
    | OrdersActionTypes.UPLOAD_MULTIPLE_ORDERS_ERROR
    | OrdersActionTypes.BULK_UPDATE_AGENT
    | OrdersActionTypes.BULK_UPDATE_AGENT_SUCCESS
    | OrdersActionTypes.BULK_UPDATE_AGENT_ERROR;
  payload: {
    actionType?: string;
    data?: OrdersData;
    createData?: OrderCreate;
    getOrder?: GetOrdersData;
    error?: string;
    orderCreateError?: string;
    updated: false;
    refreshList: false;
    downloadSample: false;
    uploading: false;
  };
}

interface State {
  list?: any[];
  total?: number;
  one?: any;
  loading?: boolean;
  value?: boolean;
}

const Orders = (state: State = INIT_STATE, action: OrdersActionType): any => {
  switch (action.type) {
    case OrdersActionTypes.BULK_UPDATE_AGENT:
      return {
        ...state,
        loading: true,
        refreshList: false,
      };
    case OrdersActionTypes.BULK_UPDATE_AGENT_SUCCESS:
      switch (action.payload.actionType) {
        case OrdersActionTypes.BULK_UPDATE_AGENT: {
          return {
            ...state,
            loading: false,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }
    case OrdersActionTypes.BULK_UPDATE_AGENT_ERROR:
      switch (action.payload.actionType) {
        case OrdersActionTypes.BULK_UPDATE_AGENT: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.GET_ORDER:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        orderCreateError: "",
        total: 0,
        updated: false,
      };
    case OrdersActionTypes.GET_ORDER_SUCCESS:
      switch (action.payload.actionType) {
        case OrdersActionTypes.GET_ORDER: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            orderCreateError: "",
            updated: false,
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.GET_ORDER_ERROR:
      switch (action.payload.actionType) {
        case OrdersActionTypes.GET_ORDER: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            orderCreateError: action.payload.error,
            updated: false,
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.CREATE_ORDER:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        orderCreateError: "",
        total: 0,
      };
    case OrdersActionTypes.CREATE_ORDER_SUCCESS:
      switch (action.payload.actionType) {
        case OrdersActionTypes.CREATE_ORDER: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            orderCreateError: "",
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.CREATE_ORDER_ERROR:
      switch (action.payload.actionType) {
        case OrdersActionTypes.CREATE_ORDER: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            orderCreateError: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.UPDATE_ORDER:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        orderCreateError: "",
        total: 0,
      };
    case OrdersActionTypes.UPDATE_ORDER_SUCCESS:
      switch (action.payload.actionType) {
        case OrdersActionTypes.UPDATE_ORDER: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            orderCreateError: "",
            updated: true,
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.UPDATE_ORDER_ERROR:
      switch (action.payload.actionType) {
        case OrdersActionTypes.UPDATE_ORDER: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            orderCreateError: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.UPDATE_STATUS_ORDER:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        orderCreateError: "",
        total: 0,
        refreshList: false,
      };
    case OrdersActionTypes.UPDATE_STATUS_ORDER_SUCCESS:
      switch (action.payload.actionType) {
        case OrdersActionTypes.UPDATE_STATUS_ORDER: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            orderCreateError: "",
            updated: true,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.UPDATE_STATUS_ORDER_ERROR:
      switch (action.payload.actionType) {
        case OrdersActionTypes.UPDATE_STATUS_ORDER: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            orderCreateError: action.payload.error,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.GET_LIST_ORDERS_SUCCESS:
      switch (action.payload.actionType) {
        case OrdersActionTypes.GET_LIST_ORDERS: {
          return {
            ...state,
            list: action.payload.data.items,
            loading: false,
            total: action.payload.data.total,
            one: null,
            error: "",
            orderCreateError: "",
            updated: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.GET_LIST_ORDERS_ERROR:
      switch (action.payload.actionType) {
        case OrdersActionTypes.GET_LIST_ORDERS: {
          // On garde list/total tels quels : un 401 pendant le refresh de
          // token ou un blip réseau ne doit PAS vider l'écran tant que le
          // user est encore loggé. Seul `error` change pour permettre au
          // composant d'afficher un toast si besoin.
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            updated: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.GET_LIST_ORDERS:
      // On garde la liste existante et le total pendant le refetch : évite
      // le flash "liste vide" à chaque changement de filtre / refresh. On
      // reset explicitement l'erreur pour ne pas afficher un toast fantôme
      // d'une requête précédente si la nouvelle réussit.
      return {
        ...state,
        loading: true,
        one: null,
        error: "",
        orderCreateError: "",
        updated: false,
        refreshList: false,
      };
    case OrdersActionTypes.DELETE_ORDER:
      return {
        ...state,
        refreshList: false,
      };
    case OrdersActionTypes.DELETE_ORDER_SUCCESS:
      switch (action.payload.actionType) {
        case OrdersActionTypes.DELETE_ORDER: {
          return {
            ...state,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.DELETE_ORDER_ERROR:
      switch (action.payload.actionType) {
        case OrdersActionTypes.DELETE_ORDER: {
          return {
            ...state,
            error: action.payload.error,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.DOWNLOAD_SAMPLE:
      return {
        ...state,
        refreshList: false,
        downloadSample: true,
      };
    case OrdersActionTypes.DOWNLOAD_SAMPLE_SUCCESS:
      switch (action.payload.actionType) {
        case OrdersActionTypes.DOWNLOAD_SAMPLE: {
          return {
            ...state,
            downloadSample: false,
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.DOWNLOAD_SAMPLE_ERROR:
      switch (action.payload.actionType) {
        case OrdersActionTypes.DOWNLOAD_SAMPLE: {
          return {
            ...state,
            error: action.payload.error,
            downloadSample: false,
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.UPLOAD_MULTIPLE_ORDERS:
      return {
        ...state,
        refreshList: false,
        uploading: true,
      };
    case OrdersActionTypes.UPLOAD_MULTIPLE_ORDERS_SUCCESS:
      switch (action.payload.actionType) {
        case OrdersActionTypes.UPLOAD_MULTIPLE_ORDERS: {
          return {
            ...state,
            uploading: false,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }

    case OrdersActionTypes.UPLOAD_MULTIPLE_ORDERS_ERROR:
      switch (action.payload.actionType) {
        case OrdersActionTypes.UPLOAD_MULTIPLE_ORDERS: {
          return {
            ...state,
            error: action.payload.error,
            uploading: false,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }
    default:
      return { ...state };
  }
};

export default Orders;
